import { render, staticRenderFns } from "./UserNotificationsDropdown.vue?vue&type=template&id=334fe48e&"
import script from "./UserNotificationsDropdown.vue?vue&type=script&lang=js&"
export * from "./UserNotificationsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./UserNotificationsDropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports